/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import PerformanceEvaluationContext from '../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext'
import CloseIcon from '@mui/icons-material/Close'
import { closeEvaluationModelModal } from '../../../context/PerformanceEvaluationContext/Actions'
import BtnAddCompetenciesModel from '../Components/BtnAddCompetenciesModel'
import SaveIcon from '@mui/icons-material/Save'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { Form } from "semantic-ui-react";
import { useQuery } from '@apollo/client'
import { CREATE_MODEL_EVALUATION,
         GET_ALL_MODELS_EVALUATION, 
         GET_ALL_COMPETENCE_EVALUATION, 
         GET_MODEL_EVALUATION_BY_ID, 
         UPDATE_MODEL_EVALUATION } from '../../../Querys/querys'
import { useMutation } from '@apollo/client'
import { SuccessfulAlert } from '../../../alerts/successAlerts'
import { ErrorAlert } from '../../../alerts/errorAlert'
import Minus from "../../../assets/svg/minus.svg"
import { v4 as uuidv4 } from 'uuid'

const ModalCreateEvaluationModel = () => {
    const {state, dispatch} = useContext(PerformanceEvaluationContext)
    const [counterTxt, setCounterTxt] = useState(0)
    const [competencies, setCompetencies] = useState<Array<any>>([])
    const [selectedCompetencies, setSelectedCompetencies] = useState('')
    const [addedCompetencies, setAddedCompetencies] = useState<Array<any>>([])
    const [calificaciones, setCalificaciones] = useState<any>({})
    const { data: resultCompetencies,startPolling, stopPolling } = useQuery(GET_ALL_COMPETENCE_EVALUATION)
    const [btnDisable, setBtnDisable] = useState<boolean>(false)
    const [modelEvaluation, setModelEvaluation] = useState<any>({})
    const [titleModal, setTitleModal] = useState<string>('')
    const [update, setUpdate] = useState<boolean>(false)
    const allCompetencies = resultCompetencies?.GET_ALL_COMPETENCE_EVALUATION
    const { data: getModelEvalById } = useQuery(GET_MODEL_EVALUATION_BY_ID, {
        variables: { id: state._id },
        skip: !state._id,
        fetchPolicy: 'no-cache'
    })
    const [initialValuesForm, setInitialValuesForm] = useState({
        name: "",
        description: "",
        competencies:"",
        //addedCompetencies: []
    })

    const [updateModelEvaluation] = useMutation(UPDATE_MODEL_EVALUATION, {
        refetchQueries: [{ query: GET_ALL_MODELS_EVALUATION }],
      })

    useEffect(() => {
        startPolling(5000);
        return () =>{
        stopPolling()
        }
    }, [allCompetencies,startPolling, stopPolling]);

    const [createNewModelEval] = useMutation(CREATE_MODEL_EVALUATION, {
        refetchQueries: [{ query: GET_ALL_MODELS_EVALUATION }]
      });

    useEffect(() => {
        if (allCompetencies) setCompetencies(allCompetencies)
    }, [allCompetencies, state._id])

    useEffect(() => {
        if(resultCompetencies?.GET_ALL_COMPETENCE_EVALUATION){
        if (allCompetencies.length > 0 ) {
           
           const copyAllCompetencies=[...allCompetencies]
           let newArray = copyAllCompetencies.sort((x, y) => x.nameCompetence.localeCompare(y.nameCompetence));           
           setCompetencies(newArray)
        }
      }
    }, [allCompetencies, resultCompetencies?.GET_ALL_COMPETENCE_EVALUATION])

    const validationSchema = Yup.object().shape({
        name: Yup.string().trim('Obligatorio').required('Obligatorio'),
        description: Yup.string(),
        competencies: Yup.string().required('Debes agregar al menos una competencia'),
        // addedCompetencies: Yup.array()
        //  .of(
        //      Yup.object().shape({
        //          id: Yup.number().required(),
        //          calificacion: Yup.string().required('Obligatorio')
        //      })
        //   )
    });

    const formik = useFormik({
        initialValues: initialValuesForm,
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (formData) => {
            const name = formData.name.trim()
            const description = formData.description.trim()
            const variablesPerformanceEvaluation:any = {
                ...formData,
                name: name,
                description: description,
                competencies: addedCompetencies.map((competence) => ({
                     id: competence.id,
                    calificacion: calificaciones[competence.uuid] 
                }))
            };
            const arrayCompetencias= variablesPerformanceEvaluation.competencies
            let error = false
            arrayCompetencias.map((cal:any)=>{               
                   if(cal.calificacion === undefined ){
                    error= true
                } 
            })

           if (error){
            return ErrorAlert({ text: 'Necesitas seleccionar una calificación' })
           }
           if (addedCompetencies.length === 0) {
                ErrorAlert({text:'Es necesario agregar competencias al curso'});
                return
            }

            try {
                setBtnDisable(true)
                if(!update) {
                    const{ addedCompetencies, ...newvariablesPerformanceEvaluation}= variablesPerformanceEvaluation  
                    await createNewModelEval({
                        variables: {
                            input: newvariablesPerformanceEvaluation
                        }
                    })
                    SuccessfulAlert({ text: "Modelo creado correctamente." })
                } else {
                    const { addedCompetencies, ...newvariablesPerformanceEvaluation } = variablesPerformanceEvaluation;
                    await updateModelEvaluation({
                        variables: {
                            input: {
                                id: parseInt(state._id),
                                name: newvariablesPerformanceEvaluation.name,
                                description: newvariablesPerformanceEvaluation.description,
                                competencies: newvariablesPerformanceEvaluation.competencies
                            }
                        }
                    });
                    console.log('VARIABLES: ', newvariablesPerformanceEvaluation )
                    SuccessfulAlert({ text: "Modelo actualizado correctamente." })
                }
                setBtnDisable(false)
                closeModalEvalModel()
            } catch (e) {
                ErrorAlert({ text: 'Ocurrió un error al crear u actualizar el modelo de evaluación.' })
                console.log("error", e)
                setBtnDisable(false)
            }
        }
    });

    useEffect(() => {
        if (state._id === '' || parseInt(state._id) === 0) {
            setTitleModal('Crear Modelo de Evaluación')
            setInitialValuesForm({
                name: "",
                description: "",
                competencies: "",
                //addedCompetencies: []
            })
            setAddedCompetencies([])
            setCalificaciones({})
            setSelectedCompetencies('')
            setUpdate(false)
        }
    }, [state._id])

    useEffect(() => {
        if (getModelEvalById && getModelEvalById.GET_MODEL_EVALUATION_BY_ID) {
            const model = getModelEvalById.GET_MODEL_EVALUATION_BY_ID;
            setModelEvaluation(model)
            console.log(model)
            setTitleModal('Actualizar Modelo de Evaluación')
            if (modelEvaluation && modelEvaluation.calificaciones?.length > 0) {
                const lastCompetenceName = model.calificaciones[model.calificaciones.length - 1]?.idCompetencies;
                const newInitialValuesForm = {
                    name: modelEvaluation?.name || "",
                    description: modelEvaluation?.descripcion || "",
                    competencies: competencies.find(comp => comp.id === lastCompetenceName)?.nameCompetence
                };
                setInitialValuesForm(newInitialValuesForm);
    
                const addedComp: any = [];
                const califValues: any = {};
                modelEvaluation.calificaciones.forEach((calificacion: { idCompetencies: any; calificacion: any }) => {
                    const competenceData = competencies.find((comp) => comp.id === calificacion.idCompetencies);
                    if (competenceData) {
                        const uuid = uuidv4();
                        addedComp.push({
                            ...competenceData,
                            calificacion: calificacion.calificacion,
                            uuid: uuid
                        });
                        califValues[uuid] = calificacion.calificacion;
                    }
                });
                setAddedCompetencies(addedComp);
                setCalificaciones(califValues);

                setCounterTxt(modelEvaluation.descripcion?.length || 0);
                setUpdate(true)
            }
        }
    }, [competencies, getModelEvalById, modelEvaluation])

    const closeModalEvalModel = () => {
        closeEvaluationModelModal('', false, dispatch)
        setCounterTxt(0)
        setAddedCompetencies([])
        setCalificaciones({})
        setSelectedCompetencies('')
        formik.resetForm()
    }

    const counterCaracter = (e: any) => {
        setCounterTxt(e.length)
    }

    const onChangeCompetencies = (e: any) => {
        setSelectedCompetencies(e.target.value)
    }

    const addCompetency = () => {
        if (selectedCompetencies && !addedCompetencies.some(comp => comp.id === selectedCompetencies)) {
            const competence = competencies.find(comp => comp.id === selectedCompetencies)
            setAddedCompetencies([...addedCompetencies, { ...competence, uuid: uuidv4() }])
            setSelectedCompetencies('')
            formik.validateForm()
        }
    }

    const filteredCompetencies = competencies.filter(
        (competence: any) => !addedCompetencies.some(comp => comp.id === competence.id)
    )

    const removeCompetency = (uuid: string) => {
        setAddedCompetencies(prevAddedCompetencies => {
        const newAddedCompetencies = prevAddedCompetencies.filter(item => item.uuid !== uuid);
        if (newAddedCompetencies.length === 0) {
            formik.setFieldValue('competencies', '');
        } else {
            //formik.setFieldValue('competencies', addedCompetencies.find(comp => comp.uuid === uuid)?.nameCompetence)
            //setSelectedCompetencies(addedCompetencies.find(comp => comp.uuid === uuid)?.nameCompetence)
            const competence = addedCompetencies.find(comp => comp.uuid === uuid);
            formik.setFieldValue('competencies', competence ? competence.id : '');
            setSelectedCompetencies(competence ? competence.id : '');
        }
        return newAddedCompetencies;
        });
        const { [uuid]: _, ...rest } = calificaciones;
        setCalificaciones(rest)
    }

    const isAddButtonDisabled = selectedCompetencies?.length === 0 || filteredCompetencies.length === 0;

    const onChangeCalificacion = (uuid: string, value: string) => {
        setCalificaciones({
            ...calificaciones,
            [uuid]: value
        })
    }

    return (
        <Dialog
            open={state.modalEvaluationModel}
            aria-labelledby="modal-dialog-title"
            className="containerMdalModel customDialogContent"
        >
            <IconButton
                aria-label="close"
                sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}
                onClick={(() => { closeModalEvalModel() })}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent>
                <Form
                    onSubmit={formik.handleSubmit}
                >
                    <DialogTitle style={{ display: 'flex', justifyContent: 'center' }}><span className="titleModalModel">{titleModal}</span></DialogTitle>
                    <DialogContent style={{ paddingTop: '5px' }}>
                        <TextField
                            label="Nombre del modelo de evaluación*"
                            name='name'
                            inputProps={{ maxLength: 50 }}
                            fullWidth={true}
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                    </DialogContent>
                    <DialogContent>
                        <TextField
                            name='description'
                            className='descriptionContainer'
                            placeholder='Descripción de la evaluación'
                            style={{ width: '101.5%' }}
                            multiline
                            rows={2}
                            inputProps={{ maxLength: 150 }}
                            value={formik.values.description}
                            onChange={(e: any) => {
                                formik.handleChange(e);
                                counterCaracter(e.target.value);
                            }}
                            onBlur={formik.handleBlur}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                        <div className="divCounterCaracter"><label className="txtConterDesc">{`${counterTxt}/150`} </label></div>
                    </DialogContent>
                    <DialogContent className='Pruebamodal'>
                        <FormControl
                            fullWidth
                            size="small"
                            variant="outlined"
                            className=""
                            error={Boolean(formik.touched.competencies && formik.errors.competencies)}
                        >
                            <InputLabel
                                id="demo-simple-select-label"
                                style={{ backgroundColor: "#FFFFFF", width: "66%" }}
                            >
                                Agregar competencia *
                            </InputLabel>
                            <Select
                                style={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    width: '90%'
                                }}
                                id='competencies'
                                name='competencies'
                                labelId='demo-simple-select-label'
                                size='small'
                                //value={selectedCompetencies}
                                value={formik.values.competencies}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    onChangeCompetencies(e)
                                }}
                            >
                                {
                                    filteredCompetencies.map((competence: any) => (
                                        <MenuItem key={competence.id} value={competence.id}>
                                            {competence.nameCompetence}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText>
                                {formik.touched.competencies && formik.errors.competencies && formik.errors.competencies}
                            </FormHelperText>
                        </FormControl>
                        <BtnAddCompetenciesModel openModal={addCompetency} disabled={isAddButtonDisabled} />
                    </DialogContent>
                    <DialogContent style={{ justifyContent: 'space-between', display: 'flex', padding: '12px 58px 0px 30px' }}>
                        <span className='calificacionMinima'>Competencias</span>
                        <span className='calificacionMinima'>Calificación mínima</span>
                    </DialogContent>
                    <DialogContent style={{ paddingTop: '10px' }}>
                        {
                            addedCompetencies.map((competence: any) => (
                                <div key={competence.uuid} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '182px', paddingLeft: '9px', justifyContent: 'space-between' }}>
                                        <ul style={{ marginBottom: '7px' }}>{competence.nameCompetence}</ul>
                                        <div className="iconoRestriccion"
                                            onClick={() => removeCompetency(competence.uuid)}
                                        >
                                            <img src={Minus} alt="minus" />
                                        </div>
                                    </div>
                                    <FormControl
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        className=""
                                        style={{ width: '132px', marginLeft: '16px', maxHeight: '60px', marginBottom: '6px' }}
                                        //error={Boolean(formik.touched.addedCompetencies)}
                                    >
                                        <InputLabel
                                            id="demo-simple-select-label"
                                            style={{ backgroundColor: "#FFFFFF", width: "70%" }}
                                        >
                                            Calificación
                                        </InputLabel>
                                        <Select
                                            style={{ height: '36px' }}
                                            size={'small'}
                                            name='calificacion'
                                            id='calificacion-select'
                                            value={calificaciones[competence.uuid] || ''}
                                            onChange={(e) => onChangeCalificacion(competence.uuid, e.target.value)}
                                        >
                                            <MenuItem value="Deficiente">Deficiente</MenuItem>
                                            <MenuItem value="Básico">Básico</MenuItem>
                                            <MenuItem value="Intermedio">Intermedio</MenuItem>
                                            <MenuItem value="Avanzado">Avanzado</MenuItem>
                                            <MenuItem value="Sobresaliente">Sobresaliente</MenuItem>
                                        </Select>
                                        {/* <FormHelperText>
                                            { formik.touched.addedCompetencies}
                                        </FormHelperText> */}
                                    </FormControl>
                                </div>
                            ))
                        }
                    </DialogContent>
                    <DialogActions>
                        <button className="botonCancelar"
                        type="button"
                            onClick={(() => {
                                formik.resetForm();
                                closeModalEvalModel();
                              })
                            }
                        >
                            <span className='bttnsTxt'>Cancelar</span>
                        </button>
                        <button
                            className="botonContinuarModel"
                            type="submit"
                            disabled={btnDisable}
                        >
                            <div className='iconoAgregarModel'>
                                <SaveIcon />
                            </div>
                            <span className='bttnsTxt'>Guardar</span>
                        </button>
                    </DialogActions>
                </Form>
            </DialogContent>
        </Dialog>
    )
}

export default ModalCreateEvaluationModel